<template>
  <app-card class="card-link d-flex justify-content-center align-items-center">
    <component
      :is="isInternalLink ? 'router-link' : 'a'"
      v-bind="linkProps"
      class="d-flex align-items-center text-black text-decoration-none h-100"
    >
      <span v-if="icon" class="icon-circle bg-card-portal rounded-circle me-3">
        <i :class="icon" />
      </span>

      <div class="lh-sm flex-grow-1">
        <slot />
      </div>
    </component>
  </app-card>
</template>

<script>
import AppCard from './app/AppCard.vue';

export default {
  components: {
    AppCard,
  },

  props: {
    to: {
      type: [String, Object],
      default: null,
    },
    href: {
      type: String,
      default: null,
    },
    icon: {
      type: String,
      default: null,
    },
  },

  computed: {
    isInternalLink() {
      return !!this.to && !this.href;
    },

    linkProps() {
      if (this.isInternalLink) {
        return {
          to: typeof this.to === 'string' ? { name: this.to } : this.to,
          href: null,
          target: null,
        };
      }

      return {
        href: this.href || '#',
        target: this.href ? '_blank' : null,
        to: null,
      };
    },
  },
};
</script>

<style scoped>
.card-link {
  cursor: pointer;
  height: 90px !important;
}

.icon-circle {
  width: 45px;
  height: 45px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  color: #fff;
  font-size: 20px;
}
</style>
